module.exports = __webpack_public_path__ + "img/tz0.1-1.2bfe593a.jpg";